import type { T } from '@common/hooks/useTranslation';

export function cookiesConsentRules(t: T) {
  return {
    required: t('validations.general.cookiesConsent.required')
  };
}
